<ion-header>
  <ion-toolbar>
    <ion-title>{{ config.title || (config.type | titlecase) }}</ion-title>
    <ion-buttons slot="end" *ngIf="config.showCloseButton !== false">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="info-modal-content">
    <!-- Icon and Message -->
    <div class="info-modal-icon">
      <ion-icon 
        [name]="iconName" 
        [color]="iconColor"
        size="large">
      </ion-icon>
    </div>
    
    <div class="info-modal-message">
      <p [innerHTML]="config.message"></p>
    </div>
  </div>
</ion-content>

<ion-footer *ngIf="config.primaryButton || config.secondaryButton">
  <ion-toolbar>
    <div class="info-modal-actions">
      <ion-button 
        *ngIf="config.secondaryButton" 
        fill="clear" 
        color="medium"
        (click)="onSecondaryAction()">
        {{ config.secondaryButton.text }}
      </ion-button>
      
      <ion-button 
        *ngIf="config.primaryButton" 
        (click)="onPrimaryAction()">
        {{ config.primaryButton.text }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
